import { ComponentConfig } from "@measured/puck"
import { HeaderGroupProps, RenderConfig } from "./RenderConfig"

export const HeaderGroup: ComponentConfig<HeaderGroupProps> = {
  label: "Tamda Group | Header",
  defaultProps: {
    className: "",
    locale: "vi",
  },
  ...RenderConfig,
}
